import React from "react";
import { Link } from "react-router-dom";
import { XCircle, ArrowLeft } from "lucide-react";

import SEO from "../components/SEO";
import { Button } from "../components/ui/button";

export default function WebshopCancelPage() {
  return (
    <>
      <SEO
        title="Betaling geannuleerd | 5999Cargo Webshop"
        description="Uw betaling is geannuleerd. Uw winkelwagen is niet verwerkt."
      />
      <section className="min-h-[70vh] bg-white py-24" data-testid="webshop-cancel-page">
        <div className="max-w-2xl mx-auto px-4 text-center">
          <XCircle className="w-14 h-14 text-red-500 mx-auto" />
          <h1 className="font-chivo font-black text-3xl sm:text-4xl text-[#082c50] mt-6">
            Betaling geannuleerd
          </h1>
          <p className="text-gray-600 mt-3 max-w-lg mx-auto">
            Uw betaling is geannuleerd of niet afgerond. Uw winkelwagen is niet verwerkt.
            U kunt teruggaan naar de webshop en opnieuw proberen.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row justify-center gap-3">
            <Button
              asChild
              className="bg-[#082c50] hover:bg-[#082c50] text-white rounded-xl font-chivo font-bold uppercase text-xs"
            >
              <Link to="/webshop" data-testid="cancel-back-shop">
                <ArrowLeft className="w-4 h-4 mr-2" />
                Terug naar winkelwagen
              </Link>
            </Button>
            <Button
              asChild
              variant="outline"
              className="rounded-xl font-chivo font-bold uppercase text-xs"
            >
              <a href="tel:+31488235999" data-testid="cancel-contact-link">Hulp nodig? Bel +31 (0) 488 23 5999</a>
            </Button>
          </div>
        </div>
      </section>
    </>
  );
}
